import { render, staticRenderFns } from "./SettingsGroupItem.vue?vue&type=template&id=3b882f7e&scoped=true&"
import script from "./SettingsGroupItem.vue?vue&type=script&lang=js&"
export * from "./SettingsGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGroupItem.vue?vue&type=style&index=0&id=3b882f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b882f7e",
  null
  
)

export default component.exports